"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_intersection_observer_1 = require("react-intersection-observer");
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const SuspenseContext_1 = require("../../contexts/SuspenseContext");
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
function getSpinnerShouldRender(hook) {
    var _a;
    if (!hook.targetPage) {
        // fetch, not paginate.
        return false;
    }
    /* always show the spinner if our status is currently loading. */
    if (hook.status === 'loading') {
        return true;
    }
    if ((hook.lastFetchedPage === ((_a = hook.meta) === null || _a === void 0 ? void 0 : _a.last_page)) || hook.isAllowed === false) {
        return false;
    }
    return hook.status === 'completed';
}
const SuspenseLoader = (props) => {
    const { children } = props;
    const { ref: inViewRef, inView } = react_intersection_observer_1.useInView({ delay: 100 });
    const { spinnerInView, hook, setSpinnerInView } = react_1.useContext(SuspenseContext_1.SuspenseContext);
    const spinnerShouldRender = getSpinnerShouldRender(hook);
    react_1.useEffect(() => {
        if (spinnerInView === inView) {
            return;
        }
        setSpinnerInView(inView);
    }, [inView, spinnerInView, setSpinnerInView]);
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    if (!spinnerShouldRender) {
        return null;
    }
    return (react_1.default.createElement("div", Object.assign({}, primitiveProps), children ? react_1.default.createElement(react_1.default.Fragment, null, children) : (react_1.default.createElement(Spinner_1.default, { ref: inViewRef }))));
};
exports.default = withJourney_1.default('j-suspense-loader', SuspenseLoader);
